
<a class="whats-app d-none" href="https://wa.me/{{numero_WhatsAppMessage}}" target="_blank">
    <i class="fa fa-whatsapp whats-app-float">
        <img id="imageWhatsApp" src="assets/img/whatsapp.png" alt="logo">
    </i>
</a>

<div class="navbar-area" ngStickyNav stickyClass="sticky-box-shadow" style="padding-top: 0px;" ngStickyNav>
    <div style="background-color: var(--mainColor); opacity: 0.85;" class="mb-2 headerRegione d-none"></div>
    <div class="container-fluid">
        <div style="height: 35px; position: absolute; top: 2px;" class="mb-2 d-none">
            <h6 class="text-white ms-2 pt-1">Ente di formazione <u><strong>accreditato</strong></u> e corsi <u><strong>autorizzati</strong></u> dalla <strong class="txtBGColor">REGIONE CAMPANIA</strong></h6>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied">
            <a class="navbar-brand" routerLink="/"><img src="assets/img/logo_new1.png" style="max-height: 100px" alt="logo"></a>
            <button class="navbar-toggler" type="button" (click)="toggleClass()">
                <span class="burger-menu">
                    <span class="top-bar"></span>
                    <span class="middle-bar"></span>
                    <span class="bottom-bar"></span>
                </span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav">
                    <li class="nav-item d-none"><a routerLink="/" class="nav-link">Home</a></li>
                    <li class="nav-item"><a class="nav-link">Contatti</a></li>
                </ul>
                <ul class="navbar-nav for-responsive">
                    <li *ngIf="detailUser" class="nav-item"><a href="elenco-corsi/i-miei-corsi" class="nav-link text-uppercase fw-bolder" style="color: var(--mainColor);">I miei corsi - corsi acquistati</a>
                    </li>
                    <li *ngIf="detailUser" class="nav-item"><a (click)="logout()" class="nav-link text-danger text-uppercase fw-bolder">Effettua il Logout</a>
                    </li>
                    <li *ngIf="!detailUser" class="nav-item"><a (click)="showLogin()" class="nav-link text-uppercase fw-bolder" style="color: var(--mainColor);">Effettua il Login</a>
                    </li>
                </ul>
                <ul class="navbar-nav for-responsive">
                    <li class="nav-item"><a  class="nav-link">Home</a></li>
                    <li class="nav-item"><a  class="nav-link">Contatti</a></li>
                </ul>
            </div>
            <div class="others-option d-flex align-items-center">
                <div class="option-item d-none">
                    <div id="imgBtnCart" class="cart-btn">
                        <a routerLink="/cart"><i class='flaticon-shopping-cart'></i><span>3</span></a>
                    </div>
                </div>
                <div class="text-right headerSocial d-none" style="position:absolute; top:5px">
                    <span class="text-white me-2">segui per info e offerte</span>
                    <a href="https://www.facebook.com/newformacademy/" target="_blank">
                        <i class='bx-fw bx-sm bx bxl-facebook-square text-white' style="padding-top: 2px;"></i>
                    </a>
                    <a href="https://www.instagram.com/new_form_academy/" target="_blank">
                        <i class='bx-fw bx-sm bx bxl-instagram-alt text-white' style="padding-top: 2px;"></i>
                    </a>
                </div>
                <div class="option-item">
                    <a *ngIf="!detailUser" id="btnLogin" (click)="showLogin()" class="default-btn" style="cursor: pointer;"><i class="flaticon-user"></i>
                        Accedi / Login<span></span>
                    </a>
                    <a *ngIf="detailUser" id="btnLogin" href="elenco-corsi/i-miei-corsi" class="default-btn" style="cursor: pointer;"><i class="flaticon-agenda"></i>
                        I miei corsi<span></span>
                    </a>
                    <a *ngIf="detailUser" id="btnLogin" class="default-btn ms-1" (click)="logout()" style="padding-left: 30px; background-color: var(--bs-danger); cursor: pointer;">
                        Esci
                    </a>
                </div>

                </div>
        </nav>
    </div>
</div>
